<div class="content-wrapper">
    <div class="content-body">
        <!-- content-header component -->
        <app-content-header [contentHeader]="contentHeader"></app-content-header>

        <!-- Basic Alerts start -->
        <section id="editar-page">
            <div class="row">
                <div id="stepper1" class="bs-stepper horizontal-wizard-example"></div>
                <div class="col-12">
                    <div class="card">
                        <div class="card-body pb-1">
                            <form #cadastroForm="ngForm">

                                <div class="card-body pb-1">

                                    <div class="col-md-12 col-12">
                                        <div class="custom-control custom-checkbox">
                                            <input (change)="checkboxChange($event.target)" type="checkbox"
                                                class="custom-control-input" name="checkboxEndereco"
                                                id="checkboxEnderecoId" [checked]="checkboxValue" />
                                            <label class="custom-control-label" for="checkboxEnderecoId">Contato
                                                principal do setor</label>
                                        </div>
                                    </div>
                                    <br>

                                    <div class="col-md-6 col-12">
                                        <div class="form-group mb-2">
                                            <label for="basicSelect">Setor</label>
                                            <select [(ngModel)]="setor" #estadoRef="ngModel" name="setor"
                                                class="form-control" id="basicSelect" required>
                                                <option value="CONTRATANTE">CONTRATANTE</option>
                                                <option value="FINANCEIRO">FINANCEIRO</option>
                                                <option value="FINANCEIRO">OUTRO</option>
                                            </select>
                                            <span *ngIf="cadastroForm.submitted && estadoRef.invalid"
                                                class="invalid-form">
                                                <small class="form-text text-danger" *ngIf="estadoRef.errors.required">
                                                    Selecione uma opção!
                                                </small>
                                            </span>
                                        </div>
                                    </div>

                                    <div class="col-md-6 col-12">
                                        <div class="form-group mb-2">
                                            <label>Nome</label>
                                            <input [(ngModel)]="nome" #emailRef="ngModel" class="form-ngModel" required
                                                type="text" name="nome" class="form-control"
                                                [class.error]="!emailRef.valid && cadastroForm.submitted"
                                                placeholder="Nome Completo" />
                                            <span *ngIf="cadastroForm.submitted && emailRef.invalid"
                                                class="invalid-form">
                                                <small class="form-text text-danger" *ngIf="emailRef.errors.required">
                                                    Campo Obrigatório!
                                                </small>
                                            </span>
                                        </div>
                                    </div>

                                    <div class="col-md-6 col-12">
                                        <div class="form-group mb-2">
                                            <label>Telefone</label>
                                            <input [(ngModel)]="telefone" #telefoneRef="ngModel" class="form-ngModel"
                                                mask="00 000000000" required type="text" name="telefone"
                                                class="form-control"
                                                [class.error]="!telefoneRef.valid && cadastroForm.submitted"
                                                placeholder="Telefone" />
                                            <span *ngIf="cadastroForm.submitted && telefoneRef.invalid"
                                                class="invalid-form">
                                                <small class="form-text text-danger"
                                                    *ngIf="telefoneRef.errors.required">
                                                    Campo Obrigatório!
                                                </small>
                                            </span>
                                        </div>
                                    </div>

                                    <div class="col-md-6 col-12">
                                        <div class="form-group mb-2">
                                            <label>Whatsapp</label>
                                            <input [(ngModel)]="whatsapp" #whatsappRef="ngModel" class="form-ngModel"
                                                mask="00 000000000" required type="text" name="whatsapp"
                                                class="form-control"
                                                [class.error]="!whatsappRef.valid && cadastroForm.submitted"
                                                placeholder="Whatsapp" />
                                            <span *ngIf="cadastroForm.submitted && whatsappRef.invalid"
                                                class="invalid-form">
                                                <small class="form-text text-danger"
                                                    *ngIf="whatsappRef.errors.required">
                                                    Campo Obrigatório!
                                                </small>
                                            </span>
                                        </div>
                                    </div>

                                    <div class="col-md-6 col-12">
                                        <div class="form-group mb-2">
                                            <label>Email</label>
                                            <input [(ngModel)]="email" #emailRef="ngModel" class="form-ngModel" required
                                                type="text" name="email" class="form-control"
                                                [class.error]="!emailRef.valid && cadastroForm.submitted"
                                                placeholder="Email" />
                                            <span *ngIf="cadastroForm.submitted && emailRef.invalid"
                                                class="invalid-form">
                                                <small class="form-text text-danger" *ngIf="emailRef.errors.required">
                                                    Campo Obrigatório!
                                                </small>
                                            </span>
                                        </div>
                                    </div>

                                    <div class="col-md-6 col-12">
                                        <div class="form-group mb-2">
                                            <label>CPF</label>
                                            <input [(ngModel)]="cpf_contratante" #emailRef="ngModel" class="form-ngModel" required [disabled]="true"
                                                type="text" name="cpf_contratante" class="form-control"
                                                [class.error]="!emailRef.valid && cadastroForm.submitted"
                                                placeholder="CPF" />
                                            <span *ngIf="cadastroForm.submitted && emailRef.invalid"
                                                class="invalid-form">
                                                <small class="form-text text-danger" *ngIf="emailRef.errors.required">
                                                    Campo Obrigatório!
                                                </small>
                                            </span>
                                        </div>
                                    </div>

                                    <br><br>

                                    <div class="col-12 mt-50">
                                        <button routerLink="/lead/editar/{{leadId}}" class="btn btn-secondary botao-cancelar"
                                            rippleEffect>Cancelar</button>
                                        <button (click)="submitForm(cadastroForm)" type="submit"
                                            class="btn btn-primary btn-next" rippleEffect>
                                            <span class="align-middle d-sm-inline-block d-none">Salvar</span>
                                            <i data-feather="arrow-right" class="align-middle ml-sm-25 ml-0"></i>
                                        </button>
                                        <br>
                                        <br>
                                        <div *ngIf="isLoading" class="spinner-border"></div>
                                    </div>

                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- Basic Alerts end -->
    </div>
</div>